#import "@/apollo/fragments/Campaign.gql"
#import "@/apollo/fragments/MasterTemplate.gql"

query CampaignLibrary($campaignId: ID!) {
    campaign(campaignId: $campaignId) {
        ...Campaign
        languages
        client {
            _id
            id
            name
            fbAdsManagerConfig {
                businessId
                adAccountId
            }
        }
        dcProfileId
        isLocked
    }
    editableGroupsByCampaign(campaignId: $campaignId) {
        name
        editables {
            _id
            name
            type
            restricted
            defaultValues {
                masterTemplateId
                value
                editableGroups
                dimensions {
                    width
                    height
                }
            }
        }
        editableGroupValues {
            _id
            value
        }
    }
    masterTemplatesByCampaign(campaignId: $campaignId) {
        ...MasterTemplate
    }
}
